export const classes = {
  box: 'place-center size-[17px] shrink-0 cursor-pointer rounded-[5px] border-[1.8px] transition-colors',
  loader: 'place-center size-[17px] shrink-0',
  unchecked: 'border-black/40 bg-transparent dark:border-white/40',
  dark: 'border-brand-accent bg-brand-accent',
  light: 'border-[#8a909c] bg-[#8a909c]',
  glyph: 'size-[11px] text-white',
};
